export const locationModels = [
  {
    name: 'location',
    fields: [
      'active',
      'address',
      // 'allDay',
      'chattbackSlug',
      'delivery',
      'deliveryAvailabilities',
      // 'deliveryCapacity',
      'deliveryCutoff',
      // 'deliveryInterval',
      'deliveryMsg',
      // 'deliveryRadius',
      'id',
      'lastCacheFlush',
      'menuStructure',
      'name',
      // 'nextDayDelivery',
      'pickup',
      'pickupAvailabilities',
      // 'pickupCapacity',
      'pickupCutoff',
      // 'pickupDays',
      // 'pickupInterval',
      'pickupMsg',
      'pronounced',
      'rockbotId',
      'roomNoLabel',
      // 'sameDayLeadTime',
      // 'sameDayPickup',
      'schedules',
      'shopOnCampus',
      'smsNumber',
      'sortOrder',
      'type',
      // 'useDeliveryCutoff',
      // 'useDeliveryRadius',
      'useRoomNo',
      'webtritionId',
      'webtritionVersion',
    ],
  },
]
